export default { sha: '4a037d39148a0c63b8f0d9594e5d016663dd9cc5', buildNumber: 'undefined' }
